import React from "react";

function RecentIcon() {
  return (
    <span className="anticon ant-recent">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fill="currentColor" transform="translate(-323 -147)">
            <g transform="translate(302 50)">
              <g transform="translate(21 80)">
                <path d="M9 17a9 9 0 11-9 9h1.636A7.364 7.364 0 109 18.636c-2.324 0-4.054.648-5.634 2.455h2.361v1.636H.818v-4.916h1.637v1.853C4.285 17.745 6.37 17 9 17zm.818 4.09v4.092h3.273v1.636H8.18v-5.727h1.637z"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default RecentIcon;
